import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import featureimageone from "./assets/nomodeling.png";
import featureimagetwo from "./assets/four.svg";
import featureimagethree from "./assets/no3dskills.png";
import featureimagefour from "./assets/three.svg";
import featureimagefive from "./assets/two.svg";
import featureimagesix from "./assets/designd.png";

const Features = () => {
  const features = [
    {
      img: featureimageone,
      title: "Library of pre-build 3D homes",
      desc: "Explore the home of your choice with our library",
    },
    {
      img: featureimagetwo,
      title: "Try 500+ wallpapers and paints",
      desc: "Apply paint and wallpapers on walls and explore",
    },
    {
      img: featureimagethree,
      title: "Designing home made simple",
      desc: "Simple design tool anyone can design his home",
    },
    {
      img: featureimagefour,
      title: "Real time visualization",
      desc: "No render required, watch the change live",
    },
    {
      img: featureimagefive,
      title: "Try 1000+ products",
      desc: "Explore products from top brands",
    },
    {
      img: featureimagesix,
      title: "Ready to use designs",
      desc: "Designs of rooms made from top designers",
    },
  ];

  return (
    <Box sx={{ py: 10, bgcolor: "#fff" }}>
      {/* Heading */}
      <Box textAlign="center" mb={8} px={2}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color: "#111827",
            fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.8rem" },
          }}
        >
          What can be done with Design247
        </Typography>
      </Box>

      {/* Features Grid */}
      <Box sx={{ maxWidth: "1200px", mx: "auto", px: 3 }}>
        <Grid container spacing={4} justifyContent="center">
          {features.map((feature, index) => (
            <Grid
              item
              key={index}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  maxWidth: 280,
                  textAlign: "center",
                  p: 3,
                  borderRadius: 3,
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                  },
                }}
              >
                {/* Image */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={feature.img}
                    alt={feature.title}
                    sx={{
                      width: 60,
                      height: 60,
                      objectFit: "contain",
                    }}
                  />
                </Box>

                {/* Text */}
                <CardContent sx={{ p: 0 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: "#111827",
                      fontSize: { xs: "1rem", sm: "1.1rem" },
                      mb: 1,
                    }}
                  >
                    {feature.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      lineHeight: 1.6,
                      fontSize: "0.9rem",
                    }}
                  >
                    {feature.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Features;
